export default {
  List: "/tcs/result",
  Create: "/tcs/result",
  Detail: "/tcs/result",
  Update: "/tcs/result",
};
